import { ParamDeclaration } from '@uirouter/react';
import { AppStateDeclaration } from '../AppStateDecleration';
import { LazyReact } from 'ui/components/shared/LazyReact';
import { dashboardsService } from 'services/dashboard/dashboards.service';

export const dashboardsHubRouteName = 'dashboard.dashboards-hub';
export const viewDashboardRouteName = 'dashboard.view-dashboard';
export const viewLegacyDashboardRouteName = 'dashboard.dashboards-hub-legacy';

export const dashboardsHubRoute: AppStateDeclaration = {
  name: dashboardsHubRouteName,
  url: '/dashboards-hub',
  params: {},
  component: props => (
    <LazyReact
      lazyImport={() => import('ui/components/DashboardsHub/DashboardsHub')}
      resolver={({ DashboardsHub }) => DashboardsHub}
      {...props}
    />
  ),
  data: {
    breadcrumb: { label: 'Dashboards Hub', beta: true },
    authenticate: true,
    title: 'Dashboards Hub',
  },
  dynamic: true,
};

export const dashboardsHubLegacyRoute: AppStateDeclaration = {
  name: viewLegacyDashboardRouteName,
  url: '/dashboards-hub/legacy',
  params: {},
  component: props => (
    <LazyReact
      lazyImport={() => import('ui/components/DashboardsHub/legacy/DashboardsHubLegacy')}
      resolver={({ LegacyDashboardsHub }) => LegacyDashboardsHub}
      {...props}
    />
  ),
  data: {
    breadcrumb: { label: 'Legacy Dashboards Hub', parent: dashboardsHubRouteName },
    authenticate: true,
    title: 'Dashboards Hub',
  },
  dynamic: true,
};

export const dashboardViewParams = [
  'start',
  'end',
  'refresh',
  'source',
  'dashboardTitle',
  'viewPanelRef',
  'drawerState',
  'varState',
] as const;

const defaultParams: Record<typeof dashboardViewParams[number] | 'panelDefinition', ParamDeclaration | null> = {
  start: null,
  end: null,
  refresh: null,
  source: null,
  dashboardTitle: null,
  panelDefinition: null,
  drawerState: null,
  viewPanelRef: {
    value: null,
    inherit: false,
  },
  varState: {
    value: null,
  },
};

export const viewDashboardRoute: AppStateDeclaration = {
  name: viewDashboardRouteName,
  url: `/dashboards-hub/view/folders/:folderId/dashboards/:dashboardId?${dashboardViewParams.join('&')}`,
  params: defaultParams,
  component: props => (
    <LazyReact
      lazyImport={() => import('ui/components/DashboardsHub/ViewUnifiedDashboard')}
      resolver={({ ViewUnifiedDashboard }) => ViewUnifiedDashboard}
      {...props}
    />
  ),
  data: {
    breadcrumb: {
      calculateLabel: async params => {
        if (params.dashboardTitle) {
          return params.dashboardTitle;
        }

        const unifiedDashboardModel = await dashboardsService.getByName(
          params.dashboardId,
          params.folderId,
          params.source,
        );

        return unifiedDashboardModel?.doc?.metadata?.name ?? params.dashboardId;
      },
      parent: dashboardsHubRouteName,
    },
    authenticate: true,
  },
  dynamic: true,
};
